import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { delayedDescAdd, delayedDescUp } from "@/api/gmToolNew/gmToolNew";
export default {
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        display_name: "",
        desc: ''
      },
      rules: {
        display_name: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }],
        desc: [{
          required: true,
          message: this.$t('pleaseEnter'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (data) {
                  _this.formData = _objectSpread({}, data);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.formData.id = '';
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var req = _this2.formData.id ? delayedDescUp : delayedDescAdd;
          req(_objectSpread({}, _this2.formData)).then(function (res) {
            if (res.code == 200) {
              _this2.$message.success(_this2.$t('operationSuccess'));

              _this2.$emit("refreshDataList");

              _this2.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.formData = {
        id: this.formData.id,
        display_name: "",
        desc: ''
      };
      this.$refs.ruleForm.resetFields();
    }
  }
};